import { createListenerMiddleware } from '@reduxjs/toolkit';
import { configActions, DeviceInfo } from '@pp/core';
import { GameRootState } from '../../GameStore';
import { DimensionsType, mwGameGridActions } from './slice';

export const mwGameGridMiddleware = createListenerMiddleware();
const portraitMedia = window.matchMedia('(orientation: portrait) and (max-width: 1023px)');
const landscapeMedia = window.matchMedia('(orientation: landscape) and (max-width: 1023px)');
const defaultBettingGridScale = 0.78;

function calculateControlsOffset(
  isWide: boolean,
  leftControlsBottom: number | null,
  wideChipStackControlWingBottom: number | null,
  contentOffsetTop: number | null
): number {
  const isIOS = DeviceInfo.getPlatform().IS_IOS;
  const viewportHeight = isIOS ? document.documentElement.clientHeight : window.innerHeight;
  if (isWide && wideChipStackControlWingBottom) {
    return viewportHeight - wideChipStackControlWingBottom;
  } else if (!isWide && portraitMedia.matches && leftControlsBottom) {
    return viewportHeight - leftControlsBottom;
  } else {
    return contentOffsetTop ? 32 : 0;
  }
}

mwGameGridMiddleware.startListening({
  actionCreator: mwGameGridActions.setDimensions,
  effect: (_, secondArg) => {
    const { dispatch, getState } = secondArg;
    const state = getState() as GameRootState; // NOSONAR
    const {
      contentOffsetTop,
      gameGridWrapperHeight,
      bettingGridWidth,
      bettingGridHeight,
      wideChipStackWidth,
      wideChipStackHeight,
      wideChipStackControlWingBottom,
      wideChipStackControlWingHeight,
      leftControlsBottom,
    } = state.mwGameGrid.dimensions;

    const updatedDimensions: Partial<Record<DimensionsType, number | null>> = {};
    const isWide = !portraitMedia.matches && !landscapeMedia.matches;

    if (contentOffsetTop && gameGridWrapperHeight) {
      updatedDimensions.playAreaHeight = gameGridWrapperHeight - contentOffsetTop;
      dispatch(configActions.setPlayAreaSize(updatedDimensions.playAreaHeight));
    }

    if (bettingGridWidth && bettingGridHeight) {
      const scale = wideChipStackWidth && isWide ? wideChipStackWidth / bettingGridWidth : defaultBettingGridScale;
      updatedDimensions.bettingGridScale = scale;

      const bettingGridVerticalDefault = bettingGridHeight * (1 - defaultBettingGridScale);
      const bettingGridVerticalChange = scale < 1 ? bettingGridHeight * (1 - scale) : bettingGridVerticalDefault;

      updatedDimensions.bettingGridShift =
        isWide && wideChipStackWidth && wideChipStackHeight
          ? wideChipStackHeight / 4 + bettingGridVerticalChange
          : bettingGridVerticalDefault;
    }

    updatedDimensions.controlsOffsetBottom = calculateControlsOffset(
      isWide,
      leftControlsBottom,
      wideChipStackControlWingBottom,
      contentOffsetTop
    );

    if (wideChipStackHeight && wideChipStackControlWingHeight) {
      updatedDimensions.wideChipStackStep = (wideChipStackHeight - wideChipStackControlWingHeight) / 2;
    }

    dispatch(mwGameGridActions.updateDimensions(updatedDimensions));
  },
});
